/* LUCRÜ™ — © 2026 LUCRÜ. All rights reserved. */
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { GlobeIcon, CaretDownIcon } from "@phosphor-icons/react";
import { useI18n, SUPPORTED_LOCALES } from "@/lib/i18n";

const LanguageSwitcher = ({ compact = false }) => {
  const { locale, setLocale } = useI18n();
  const [open, setOpen] = useState(false);
  const current = SUPPORTED_LOCALES.find((l) => l.code === locale) || SUPPORTED_LOCALES[0];

  return (
    <div className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="language-switcher"
        className={`inline-flex items-center gap-1.5 rounded-full border border-[#222233] bg-[#0F0F16] hover:border-[#00E5FF]/50 transition-colors ${compact ? "px-2 py-1 text-[11px]" : "px-3 py-1.5 text-xs"}`}
      >
        <GlobeIcon size={compact ? 12 : 14} />
        <span className="uppercase tracking-wider">{current.code}</span>
        <CaretDownIcon size={10} />
      </button>
      <AnimatePresence>
        {open && (
          <>
            <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
            <motion.div
              className="absolute right-0 mt-2 w-44 bg-[#0F0F16] border border-[#222233] rounded-xl p-1 z-50 shadow-xl"
              initial={{ opacity: 0, y: -4 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -4 }}
            >
              {SUPPORTED_LOCALES.map((l) => (
                <button
                  key={l.code}
                  onClick={() => {
                    setLocale(l.code);
                    setOpen(false);
                  }}
                  data-testid={`language-option-${l.code}`}
                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-xs text-left transition-colors ${
                    l.code === locale ? "bg-[#00E5FF]/10 text-[#00E5FF]" : "text-white/70 hover:bg-white/5"
                  }`}
                >
                  <span className="text-base">{l.flag}</span>
                  <span className="flex-1">{l.label}</span>
                  {l.code === locale && <span className="text-[9px]">✓</span>}
                </button>
              ))}
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default LanguageSwitcher;
